'use strict';

var slicedToArray = require('../../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../../Styles/withStyles.js');
require('prop-types');
var Button = require('../../../Inputs/Buttons/Button/Button.js');
var Add = require('../../../../IconsAndImages/Icons/Add.js');
var ListItemText = require('../../../DataDisplay/List/ListItemText.js');
var Divider = require('../../../DataDisplay/Divider/Divider.js');
var AddJob = require('../../../../IconsAndImages/Icons/AddJob.js');
var AddEstimate = require('../../../../IconsAndImages/Icons/AddEstimate.js');
var AddEvent = require('../../../../IconsAndImages/Icons/AddEvent.js');
var AddCustomer = require('../../../../IconsAndImages/Icons/AddCustomer.js');
var Popover = require('../../../../node_modules/@material-ui/core/esm/Popover/Popover.js');
var MenuList = require('../../../../node_modules/@material-ui/core/esm/MenuList/MenuList.js');
var ListItem = require('../../../../node_modules/@material-ui/core/esm/ListItem/ListItem.js');
var ListItemIcon = require('../../../../node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    newButton: {
      margin: '0 12px'
    },
    newButtonPlusPosition: {
      margin: '0 6px 0 -6px'
    }
  };
};

var NewButton = function NewButton(_ref) {
  var classes = _ref.classes,
      showJob = _ref.showJob,
      showEstimate = _ref.showEstimate,
      showEvent = _ref.showEvent,
      showCustomer = _ref.showCustomer;
      objectWithoutProperties(_ref, ["classes", "showJob", "showEstimate", "showEvent", "showCustomer"]);

  var _useState = React.useState(false),
      _useState2 = slicedToArray(_useState, 2),
      newButtonMenuOpen = _useState2[0],
      setNewButtonMenuOpen = _useState2[1];

  var _useState3 = React.useState(null),
      _useState4 = slicedToArray(_useState3, 2),
      newButtonMenuAnchor = _useState4[0],
      setNewButtonMenuAnchor = _useState4[1];

  var handleNewButtonMenuOpen = function handleNewButtonMenuOpen(event, open) {
    setNewButtonMenuAnchor(event.currentTarget);
    setNewButtonMenuOpen(open);
  };

  return React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(Button["default"], {
    variant: "contained",
    color: "primary",
    className: classes.newButton,
    onClick: function onClick(event) {
      return handleNewButtonMenuOpen(event, true);
    }
  }, React__default["default"].createElement(Add, {
    className: classes.newButtonPlusPosition
  }), "New"), React__default["default"].createElement(Popover["default"], {
    open: newButtonMenuOpen,
    anchorEl: newButtonMenuAnchor,
    anchorReference: "anchorEl",
    onClose: function onClose(event) {
      handleNewButtonMenuOpen(event, false);
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, React__default["default"].createElement(MenuList, null, showJob && React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(ListItem["default"], {
    button: true,
    key: 'z',
    onClick: function onClick() {
    }
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(AddJob, null)), React__default["default"].createElement(ListItemText, {
    primary: "Job"
  })), React__default["default"].createElement(Divider, null)), showEstimate && React__default["default"].createElement(ListItem["default"], {
    button: true,
    key: 'x',
    onClick: function onClick() {
    }
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(AddEstimate, null)), React__default["default"].createElement(ListItemText, {
    primary: "Estimate"
  })), showEvent && React__default["default"].createElement(ListItem["default"], {
    button: true,
    key: 'y',
    onClick: function onClick() {
    }
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(AddEvent, null)), React__default["default"].createElement(ListItemText, {
    primary: "Event"
  })), showCustomer && React__default["default"].createElement(ListItem["default"], {
    button: true,
    key: 'w',
    onClick: function onClick() {
    }
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(AddCustomer, null)), React__default["default"].createElement(ListItemText, {
    primary: "Customer"
  })))));
};

var NewButton$1 = withStyles["default"](styles)(NewButton);

module.exports = NewButton$1;
